import {
  Market,
  PrivacySettingToggles,
  PaymentProviderGroup,
} from '../types/market';
import { se as adConfig } from '../ads';

const market: Market = {
  countryCode: 'se',
  active: true,
  permanentRedirect: true,
  sitename: 'Prisjakt',
  redirectHosts: ['m.prisjakt.nu', 'prisjakt.nu', 'beta.prisjakt.nu'],
  superSearchEndpoint: 'https://search.cloud.pji.nu/rfe',
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  useClassicUrls: true,
  classicProxy: {
    host: 'int-classic-se.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['sv'],
  locale: 'sv-se',
  localeStandard: 'sv-SE',
  sites: {
    production: 'https://www.prisjakt.nu',
    classic: 'https://classic.prisjakt.nu',
    analytics: 'https://classic.prisjakt.nu/analytics/store',
    brands: 'https://research.prisjakt.nu',
    forum: 'https://www.minhembio.com/forum',
    mobile: 'https://m.prisjakt.nu',
  },
  api: {
    default: 'http://int-api-se.cloud.pji.nu:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '2': '2019-11-29', // BF
      '6': '2019-12-02', // CM
      '3': '2019-12-25', // Boxing day
      '16': '2020-11-11', // Singles Day
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'sv',
  timezone: 'Europe/Stockholm',
  currencyCode: 'SEK',
  url: {
    campaigns: '/tema',
    legacy: {
      brand: '/tillverkare.php',
      category: '/kategori.php',
      fight: '/fight.php',
      forum: 'https://www.minhembio.com/forum',
      info: '/info.php',
      lists: '/list.php',
      minhembio: 'https://www.minhembio.com',
      plugin: '/plugins/',
      product: '/produkt.php',
      raw: '/expert.php',
      store_info: '/butiksinfo.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.prisjakt.nu',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/prisjakt/',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/Prisjakt',
      clientID: '113897408641722',
      clientSecret: '8ea1e037c626728369a3cbf43b2685e0',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      // @TODO: Accounts created on RFE platform fails to authorize. Disable until we can find out why.
      enableLogin: false,
      link: 'https://twitter.com/Prisjaktnu',
      consumerKey: 'tLlmhAxh4ZkHGQVKS6Bzn3PcY',
      consumerSecret: 'l4x3E3ttEhqDXP0I3SdqE2lBWV2VSS6T8LjAeEQgbJ1WeRFZ98',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
    schibsted: {
      enableLogin: true,
      clientID: '5f5f8396cab19b071816d268',
      clientSecret: 'Q4QAYLcgX7IyAwl9khEE',
      host: 'https://login.schibsted.com',
      callbackURL: '/_internal/auth/schibsted/callback',
    },
  },
  email: {
    noreply: 'noreply@prisjakt.nu',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
    offerImages: 'https://www.prisjakt.nu/offers-images',
  },
  routes: {
    themes: {
      path: '/tema',
    },
    campaign: {
      path: '/tema/:name',
    },
    productAlert: {
      path: '*--p:id/bevaka',
      relativePath: '/bevaka',
    },
    productCompare: {
      path: '/jamfor/produkter/:productIds?',
    },
    shopOfTheYear: {
      path: '/arets-butik',
    },
    shopOfTheYearWinners: {
      path: '/arets-butik/:section',
    },
    editorialContentListing: {
      path: '/artiklar',
    },
    categoryIndex: {
      path: '/kategorier',
    },
    expertProductTest: {
      path: '/tester/:slug?',
      relativePath: '/tester',
    },
    expertToplists: {
      path: '/topplistor/:slug?',
      relativePath: '/topplistor',
    },
    expertGuide: {
      path: '/guider/:slug?',
      relativePath: '/guider',
    },
    expertLandingPage: {
      path: '/experter',
    },
    expertProfile: {
      path: '/experter/profil/:slug?',
      relativePath: '/experter/profil',
    },
    expertCategory: {
      path: '/experter/:slug',
      relativePath: '/experter',
    },
    changelog: {
      path: '/changelog',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Deals under 500 kr',
      path: '?price=19-500&sort=rank%7Cdesc',
    },
    {
      title: 'Arbeta hemifrån',
      path: '?category=555%7C1594%7C148',
    },
    {
      title: 'Deals 500 - 1000 kr',
      path: '?sort=product.popularity.total&price=500-1000',
    },
    {
      title: 'Populära hörlurar',
      path: '?category=148&sort=product.popularity.total',
    },
    {
      title: 'Vitvaror',
      path: '?category=504',
    },
    {
      title: 'Till barnen',
      path: '?category=1815%7C1553',
    },
  ],
  infoPages: [9, 5, 15, 10, 12, 4, 6, 7, 14, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    careers: 'careers',
    articles: 'articles',
    shopOfTheYear: 'shopOfTheYear',
    categoryIndex: 'categoryIndex',
    expertLogin: 'expertLogin',
    experts: 'experts',
    supportPage: 'supportPage',
    newsroom: 'newsroom',
    blackFriday: 'blackFriday',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: 'B36O',
    gansubFormId: '9wO6UTbrO',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  ads: { ...adConfig, active: true },
  paymentProviders: {
    priorities: [
      'KLARNA',
      'SVEA_WEB_PAY',
      'SWISH',
      'PAYPAL',
      'VIPPS',
      'AMEX',
      'VISA',
      'MASTER_CARD',
      'DINERS',
    ],
    groupPriorities: [
      PaymentProviderGroup.Invoice,
      PaymentProviderGroup.Direct,
      PaymentProviderGroup.Card,
    ],
  },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/cookiepolicy--ipYmj0eBAAACIA1fgC',
      privacyUrl: '/info/personuppgiftspolicy--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showSchibstedCoBranding: true,
  showClassicSwitch: true,
  showBrandingTagline: true,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: true,
  structuredData: {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    legalName: 'Prisjakt Sverige AB',
    areaServed: 'SE',
    url: 'https://www.prisjakt.nu',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Storgatan 47 A',
      addressLocality: 'Ängelholm',
      postalCode: '262 32',
      addressCountry: 'Sweden',
    },
    logo: 'https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_se.svg',
    sameAs: [
      'https://www.facebook.com/Prisjakt',
      'https://twitter.com/prisjaktnu',
    ],
  },
  cdnCache: {
    enabled: true,
    mode: 'external',
  },
  productVariants: {
    legacySupportedCategories: ['103'],
    shoeSizeStandard: 'EU',
  },
  articles: {
    aboutExperts: {
      path: '/info/transparenslofte-prisjakt-experter--ecYmerohAAACMA0AaC',
    },
    recruiting: {
      path: '/vi-soker-nya-experter--ecYS9l2BMAACEAw3yp',
    },
  },
  experts: {
    enabled: true,
  },
  keywordLandingPagesEnabled: true,
  featuredCollectionsEnabled: true,
};

export default market;
